import React, { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/Button';

type Props = {
  children: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: 'transparent' | '' | 'primary' | 'danger';
  size?: 'full' | 'medium' | 'small' | 'large' | '';
  active?: boolean;
  top?: boolean;
  left?: boolean;
  right?: boolean;
  bottom?: boolean;
  disabled?: boolean;
  className?: string;
  testId?: string;
};

const variantMap: Record<string, string> = {
  '': 'bg-muted hover:bg-secondary text-foreground',
  transparent: 'bg-transparent hover:bg-secondary text-foreground',
  primary: 'bg-primary hover:bg-primary/80 text-primary-foreground',
  danger: 'bg-red-scale-50 hover:bg-red-scale-100 text-destructive',
};

const sizeMap: Record<string, string> = {
  '': 'h-[38px] w-[38px]',
  medium: 'h-8 w-8',
  small: 'h-auto w-auto p-1',
  large: 'h-[38px] w-[38px]',
  full: 'h-full w-full',
};

const rotationMap: Record<string, string> = {
  top: '[&_svg]:rotate-180',
  right: '[&_svg]:-rotate-90',
  left: '[&_svg]:rotate-90',
  bottom: '[&_svg]:rotate-180',
};

export const IconButton = ({
  children,
  onClick,
  variant = '',
  size = '',
  active = false,
  top = false,
  left = false,
  right = false,
  bottom = false,
  disabled = false,
  className,
  testId,
}: Props) => {
  const rotation = top ? 'top' : right ? 'right' : left ? 'left' : bottom ? 'bottom' : null;

  return (
    <Button
      type='button'
      variant='ghost'
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={cn(
        'flex items-center justify-center rounded-md border border-transparent shrink-0 p-0 transition-all',
        variantMap[variant],
        sizeMap[size],
        active && 'bg-secondary border-secondary',
        rotation && rotationMap[rotation],
        className,
      )}
    >
      {children}
    </Button>
  );
};
